let agGridLibraryPromise: Promise<void>;

async function loadAgGridLibrary() {
  try {
    window['agGrid'] = await import('ag-grid-enterprise');
  } catch (e) {
    throw new Error('Failed to load ag-Grid script:\n' + e.message);
  }
}

export async function lazySetupAgGridLibrary({ LicenseKey }: { LicenseKey: string }) {
  // Lazy-load the ag-grid library only once
  if (!agGridLibraryPromise) agGridLibraryPromise = loadAgGridLibrary();
  await agGridLibraryPromise;

  // Set the ag-Grid license key
  if (window['agGrid'] && window['agGrid'].LicenseManager) {
    window['agGrid'].LicenseManager.setLicenseKey(LicenseKey);
  }
}
